export default __webpack_public_path__ + "static/media/censuringstrike1.4e35661e.png";